import { render, staticRenderFns } from "./abnormalSum.vue?vue&type=template&id=42741b61&scoped=true&"
import script from "./abnormalSum.vue?vue&type=script&lang=js&"
export * from "./abnormalSum.vue?vue&type=script&lang=js&"
import style0 from "./abnormalSum.vue?vue&type=style&index=0&id=42741b61&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42741b61",
  null
  
)

export default component.exports